import Vue from 'vue'
import VueResource from 'vue-resource'
import toastr from '../toastr'

if ($('#register_user').length) {
  Vue.use(VueResource)

  var loginForm = $('#register_user')

  if (loginForm.length > 0) {
    new Vue({
      el: '#register_user',
      data: {
        errors: {},
        formData: {
          fosUserRegistrationForm: {
            username: '',
            email: '',
            plainPassword: {
              first: '',
              second: ''
            },
            _token: ''
          }
        }
      },
      http: {
        emulateJSON: true,
        emulateHTTP: true
      },
      mounted() {
        this.formData.fosUserRegistrationForm._token = $('#fos_user_registration_form__token').val()
      },
      methods: {
        submitForm() {
          this.errors = {}
          let url = Routing.generate('fos_user_registration_register')

          this.$http.post(url, this.formData).then(response => {
            toastr.success(Translator.trans(response.body.message))

            setTimeout(() => {
              $(location).attr('href', Routing.generate('fos_user_registration_confirmed'))
            }, 1000)
          }, response => {
            this.errors = response.body
          })
        }
      }
    })
  }
}
